export default "__VITE_ASSET__ARXkHybA__"